import cn from "classnames";
import {
  default as ReactCountryFlag,
  ReactCountryFlagProps,
} from "react-country-flag";
import { isCryptoCode } from "shared/src/cryptoUtils";
import { CryptoFlag } from "shared/src/CryptoFlag";

type CountryFlagProps = ReactCountryFlagProps;

export const CountryFlag = ({
  countryCode,
  className,
  ...props
}: CountryFlagProps) => {
  return isCryptoCode(countryCode) ? (
    <CryptoFlag
      cryptoCode={countryCode}
      className={cn("rounded-full", className)}
    />
  ) : (
    <ReactCountryFlag
      {...props}
      countryCode={countryCode}
      className={cn(className, "rounded-full")}
      // NOTE (HJST): For some reason adding 'objectFit: cover' as tailwind className doesnt apply the styling
      style={{ objectFit: "cover" }}
    />
  );
};
